import {ProductDetailsSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/article_detail_page/v1/product_details.types';
import {SelectedSize} from '../../../../features/SizeSelection/hooks/useSelectedSizeState';

export const useArticleNumberFromProductDetailResponse = (
  articleDetails: ProductDetailsSection['articleDetails'],
  {selectedSize}: {selectedSize: SelectedSize},
) => {
  const {defaultArticleNumber, articleNumbers} = articleDetails;
  return selectedSize
    ? articleNumbers.find(article => {
        return article.sizeId === selectedSize.sizeId;
      })?.articleNumber
    : defaultArticleNumber;
};
